export default "__VITE_ASSET__Bbuj_sme__"